import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '20px',
      color: '#fff'
    }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>404</h1>
      <h2 style={{ marginBottom: '20px' }}>Página no encontrada</h2>
      <p style={{ marginBottom: '30px', maxWidth: '500px' }}>
        Lo sentimos, la página que estás buscando no existe o ha sido movida.
      </p>
      <Link 
        to="/" 
        style={{
          padding: '10px 20px',
          backgroundColor: '#ffb300',
          color: '#000',
          textDecoration: 'none',
          borderRadius: '4px',
          fontWeight: 'bold',
          transition: 'background-color 0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#ffc107'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffb300'}
      >
        Volver al Inicio
      </Link>
    </div>
  );
};

export default NotFound;
